(function() {

  "use strict";

  angular.module("PrintixProviderTenant", [])

    .constant("RequiredTenantModelProperties", [
      "hostingDomains",
      "name"
    ])

    .constant("DISCOVERY_TASKS", {
      DISCOVER_ENVIRONMENT: "DISCOVER_ENVIRONMENT"
    })

    .constant("PRINT_QUEUE_ID_SIGN_PLACEMENT", {
      SIGNID_AFTER: "SIGNID_AFTER",
      SIGNID_BEFORE: "SIGNID_BEFORE",
      SIGNID_HIDDEN: "SIGNID_HIDDEN"
    })

    .constant("TenantEmbeddedProperties", "?embed=PUSHER_CLIENT_INFO,progressingTasks,toDos,wsCountPerOs,securePrintConfiguration,printRuleConfiguration,openIssues,tenantIdentityProviders,subscriptionStatus,partnerLinks")

    .constant("TRANSACTIONS_ITEMS_PER_PAGE", 10)

    .factory("TenantModel", ["$rootScope", "Utils", "$filter", "RequiredTenantModelProperties", "PrintixErrorConstants",
      "$location", "SETUP_ASSISTANT", "URLS", "$http", "$q", "TenantEmbeddedProperties", "uuid", "$window", '$httpParamSerializer',
      function($rootScope, Utils, $filter, RequiredTenantModelProperties, PrintixErrorConstants, $location, SETUP_ASSISTANT,
        URLS, $http, $q, TenantEmbeddedProperties, uuid, $window, $httpParamSerializer) {
        return function(tenantDataReceived) {
          //START VARIABLES**************************************************************************************/
          var TenantModel = {},
            TenantModelPrivate = {};
          //END VARIABLES****************************************************************************************/

          //START init*******************************************************************************************/
          TenantModel.init = function(tenantDataReceived) {
            if (Utils.objectPropertiesCheck(tenantDataReceived, RequiredTenantModelProperties)) {
              TenantModel.info = angular.copy(tenantDataReceived);
              TenantModel.info.todoMap = TenantModel.setTodoListMap()
              TenantModel.options = {
                isSelected: false,
                setupAssistantIsClosed: false,
              };
              TenantModel.customProperties = {};
              TenantModelPrivate.normalizeLinks();
            } else {
              throw "TenantModel: tenantDataReceived is not valid";
            }
          };
          //END init*********************************************************************************************/

          //START TenantModel************************************************************************************/
          TenantModel.isPowerPDFEnabled = function() {
            return !!TenantModel.info._embedded.productsAndFeatures.products?.POWER_PDF?.enabled;
          }

          TenantModel.isPrintixEnabled = function() {
            return  !!(TenantModel.info._embedded.productsAndFeatures.products?.ZERO?.enabled ||
                       TenantModel.info._embedded.productsAndFeatures.products?.FREEDOM?.enabled ||
                       TenantModel.info._embedded.productsAndFeatures.products?.EXPERIMENTAL?.enabled)
          }

          TenantModel.isPowerPDFOnly = function() {
            return this.isPowerPDFEnabled() && !this.isPrintixEnabled();
          }

          TenantModel.isPrintixOnly = function() {
            return !this.isPowerPDFEnabled() && this.isPrintixEnabled();
          }

          TenantModel.setTodoListMap = function() {
            var todoList = {}
            if (TenantModel.info._embedded.toDos) {
              TenantModel.info._embedded.toDos.forEach((todo) => {
                todoList[todo.action] = todo
              })
            }
            return todoList;
          }

          TenantModelPrivate.normalizeLinks = function() {
            angular.forEach(TenantModel.info._links, function(link, index) {
              if (angular.isObject(link) && !angular.isArray(link)) {
                var linkClean = link.href.split("?")[0];
                TenantModel.info._links[index].href = linkClean;
              }
            });
            var selfHrefSplit = TenantModel.info._links.self.href.split("/");
            TenantModel.customProperties.id = selfHrefSplit[selfHrefSplit.length - 1];
            TenantModel.customProperties.showTrialbar = TenantModel.showTrialExpireNotification();
          };

          TenantModelPrivate.replaceInfo = function(embeddedKey, data, doNotReplaceEmbeddedAndLinks) {
            if (!TenantModel.info._embedded) {
              TenantModel.info._embedded = {};
            }
            if (embeddedKey) {
              TenantModel.info._embedded[embeddedKey] = angular.copy(data);
            } else {
              var embedded = angular.copy(TenantModel.info._embedded);
              var links = angular.copy(TenantModel.info._links);
              TenantModel.info = angular.copy(data);
              if (!doNotReplaceEmbeddedAndLinks) {
                TenantModel.info._embedded = embedded;
                TenantModel.info._links = links;
              }
              TenantModelPrivate.normalizeLinks();
              TenantModel.info.groupsEnabled = TenantModel.isGroupsEnabled(data)
              TenantModel.info.todoMap = TenantModel.setTodoListMap()
            }
          };

          TenantModelPrivate.getProgressingTask = function(url) {
            if (url) {
              var deferred = $q.defer();
              $http.get(url).then(function(response) {
                if (!TenantModel.info._embedded.progressingTasks) {
                  TenantModel.info._embedded.progressingTasks = [];
                }
                TenantModel.info._embedded.progressingTasks.add(angular.copy(response.data));
                deferred.resolve(response);
              }).catch(function(error) {
                deferred.reject(error);
              });
              return deferred.promise;
            } else {
              throw "TenantModelPrivate.getProgressingTask: url is missing";
            }
          };

          TenantModel.isGroupsEnabled = function (data) {
            if (data._embedded.tenantIdentityProviders) {
              const providers = data._embedded.tenantIdentityProviders.providers;
              for (const providerKey in providers) {
                const directories = providers[providerKey].directories;
                for (const directoryKey in directories) {
                  const dir = directories[directoryKey];
                  if (dir.groups_enabled) {
                    return true;
                  }
                  if (dir._links && dir._links['px:scim_provisioning']) {
                    return true;
                  }
                }
              }
            }
            return false;
          };

          TenantModel.showTrialExpireNotification = function () {
            switch (TenantModel.info._embedded.subscriptionStatus?.status) {
              case 'UNSUBSCRIBE_AFTER_END_PERIOD':
              {
                const subscriptionExpiryDays = $filter('amDifference')(TenantModel.info._embedded.subscriptionStatus.unsubscribeTime, null, 'days');
                return subscriptionExpiryDays < 28;
              }
              case 'EXPIRE_AFTER_TRIAL':
              case 'DEACTIVATED':
              case 'DELETED':
                return true;
              // case 'NOT_FOR_RESALE':
              // case 'SUBSCRIBE_AFTER_TRIAL':
              // case 'SUBSCRIBED':
              // case 'UNKNOWN':
              default:
                return false;
            }
          };

          TenantModel.isTrialExpired = function() {
            var trialEndTime = $filter("amDifference")(TenantModel.info._embedded.subscriptionStatus.trialExpiryDate, null, "milliseconds");
            var deactivatedTime = TenantModel.info.deactivatedTime;
            if (trialEndTime < 0 || deactivatedTime) {
              return true;
            } else {
              return false;
            }
          };

          TenantModel.unsubscribed = function () {
            if (TenantModel.info._embedded.subscriptionStatus.unsubscribeTime) {
              return true
            } else {
              return false
            }
          }

          TenantModel.getTrialExpireNotificationText = function () {
            switch (TenantModel.info._embedded.subscriptionStatus.status) {
              case 'EXPIRE_AFTER_TRIAL':
              {
                const trialExpiryDays = $filter('amDifference')(TenantModel.info._embedded.subscriptionStatus.trialExpiryDate, null, 'days', true);
                if (trialExpiryDays >= 15) {
                  // Trial ends on date
                  const translation = $filter('translate')('TrialEnds');
                  const trialExpiryDate = $filter('amDateFormat')(TenantModel.info._embedded.subscriptionStatus.trialExpiryDate, 'LL');
                  return $filter('stringular')(translation, trialExpiryDate);
                }
                if (trialExpiryDays >= 2) {
                  // Trial ends in days
                  const translation = $filter('translate')('TrialEndsInDays');
                  return $filter('stringular')(translation, Math.trunc(trialExpiryDays));
                }
                if (trialExpiryDays > 0) {
                  // Trial ends in hours or minutes
                  const translation = $filter('translate')('TrialEndsIn');
                  const trialExpirySeconds = $filter('amDifference')(TenantModel.info._embedded.subscriptionStatus.trialExpiryDate, null, 'seconds');
                  const trialExpiryFormatted = $filter('amDurationFormat')(trialExpirySeconds, 'seconds');
                  return $filter('stringular')(translation, trialExpiryFormatted);
                }
                // Trial has expired
                const translation = $filter('translate')('YourAccountHasExpired');
                return $filter('stringular')(translation, $rootScope.currentOEM);
              }
              case 'UNSUBSCRIBE_AFTER_END_PERIOD':
              {
                const translation = $filter('translate')('SubscriptionCancelDate');
                const unsubscribeTime = $filter('amDateFormat')(TenantModel.info._embedded.subscriptionStatus.unsubscribeTime, 'LL');
                return translation + ' - ' + unsubscribeTime;
              }
              case 'DEACTIVATED':
              case 'DELETED':
              {
                const translation = $filter('translate')('YourAccountHasExpired');
                return $filter('stringular')(translation, $rootScope.currentOEM);
              }
              default:
                return undefined;
            }
          };

          TenantModel.manageProgressingTasks = function(progressReceived) {
            if (progressReceived) {
              if (TenantModel.info._embedded.progressingTasks && TenantModel.info._embedded.progressingTasks.length > 0) {
                var taskFound = TenantModel.info._embedded.progressingTasks.findElement({
                  _links: {
                    self: {
                      href: progressReceived.task
                    }
                  }
                });
                if (taskFound) {
                  var progressFound = taskFound._embedded.progress.findElement({
                    subject: progressReceived.subject
                  });
                  if (progressFound) {
                    if (progressReceived.current > progressFound.current) {
                      progressFound.current = angular.copy(progressReceived.current);
                    }
                  } else {
                    taskFound._embedded.progress.add(progressReceived);
                  }
                } else {
                  TenantModelPrivate.getProgressingTask(progressReceived.task);
                }
              } else {
                TenantModelPrivate.getProgressingTask(progressReceived.task);
              }
            } else {
              throw "TenantModel.manageProgressingTasks: progress is missing";
            }
          };

          TenantModel.checkToDoList = function() {
            if (SETUP_ASSISTANT &&
              TenantModel.info._embedded.toDos &&
              $location.path() !== URLS.SETUP_ASSISTANT &&
              $location.path() !== URLS.SUPPORT) {
              if ((TenantModel.info._embedded.toDos.findElement({
                    action: SETUP_ASSISTANT.SHOW_INTRODUCTION
                  }) ||
                  TenantModel.info._embedded.toDos.findElement({
                    action: SETUP_ASSISTANT.DOWNLOAD_CLIENT
                  }) ||
                  TenantModel.info._embedded.toDos.findElement({
                    action: SETUP_ASSISTANT.AWAIT_WORKSTATION
                  }) ||
                  TenantModel.info._embedded.toDos.findElement({
                    action: SETUP_ASSISTANT.AWAIT_INITIAL_DISCOVERY
                  }) ||
                  TenantModel.info._embedded.toDos.findElement({
                    action: SETUP_ASSISTANT.OPEN_DASHBOARD
                  })) &&
                !TenantModel.options.setupAssistantIsClosed) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          };

          TenantModel.inviteTechnician = function(data) {
            if (data) {
              return $http.post(TenantModel.info._links["px:userTasks"].href, data);
            } else {
              throw "TenantModel.prototype.inviteTechnician : data is missing";
            }
          };

          TenantModel.testTenantAdConfig = function(urlParameters, credentialParameters) {
            if (urlParameters && credentialParameters && credentialParameters.userName && credentialParameters.password) {

              var data = {
                adConfig: JSON.stringify(urlParameters),
                username: credentialParameters.userName,
                password: credentialParameters.password
              }

              return $http.post(this.info._embedded.authenticationConfiguration._links["px:testAdConfig"].href, $httpParamSerializer(data), {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                }
              });
            } else {
              throw "TenantModel.prototype.testTenantAdConfig : urlParameters or credentialParameters are missing";
            }
          };

          TenantModel.refreshInfo = function(url, embeddedKey) {
            var deferred = $q.defer();
            if (url && embeddedKey) {
              $http.get(url).then(function(response) {
                TenantModelPrivate.replaceInfo(embeddedKey, response.data);
                deferred.resolve(response);
              }).catch(function(error) {
                deferred.reject(error);
              });
            } else {
              $http.get(TenantModel.info._links.self.href + TenantEmbeddedProperties).then(function(response) {
                TenantModelPrivate.replaceInfo(null, response.data, true);
                deferred.resolve(response);
              }).catch(function(error) {
                deferred.reject(error);
              });
            }
            return deferred.promise;
          };

          TenantModel.removeToDoItem = function(todo) {
            var todo_it = TenantModel.info._embedded.toDos.find(todo_it => todo_it.action === todo.action);
            if (todo && TenantModel.info._embedded.toDos && todo_it) {
              var deferred = $q.defer();
              $http.delete(todo._links.self.href).then(function(response) {
                TenantModel.info._embedded.toDos.remove(todo);
                TenantModel.info.todoMap = TenantModel.setTodoListMap()
                $rootScope.$broadcast('CHECK_TODO_LIST');
                deferred.resolve(response);
              }).catch(function(error) {
                deferred.reject(error);
              });
              return deferred.promise;
            } else {
              throw "TenantModel.prototype.removeTodoItem : todo or tenant.info._embedded.toDos are missing";
            }
          };

          TenantModel.discoverEnvironment = function(workstation, snmpConfiguration) {
            var data = null;
            if (workstation) {
              data = {
                workstation: workstation.info._links.self.href,
                snmpConfiguration: snmpConfiguration.info._links.self.href
              };
            }
            return $http.post(TenantModel.info._links["px:discoverEnvironment"].href, data);
          };

          TenantModel.changeBillingData = function(originalBillingData, changedBillingData) {
            if (changedBillingData) {
              var patchObjectArray = Utils.getObjectsDifferencesForPatching(originalBillingData, changedBillingData);
              if (patchObjectArray && patchObjectArray.length > 0) {
                var deferred = $q.defer();
                $http.patch(changedBillingData._links.self.href, patchObjectArray).then(function(response) {
                  deferred.resolve(response);
                }).catch(function(error) {
                  deferred.reject(error);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw "TenantModelPrivate.changeBillingData: changedBillingData is missing";
            }
          };

          TenantModel.getClientSecret = function (billingData) {
            var deferred = $q.defer();
            var url = billingData._links['px:stripeSetupIntent'].href;
            $http.post(url).then(function(response) {
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }

          TenantModel.sendStripePaymentMethodId = function(paymentMethodId, billingData) {
            var deferred = $q.defer();
            var payload = {
              paymentMethodId: paymentMethodId
            }
            var url = billingData._links['px:stripeAttachPaymentMethod'].href;
            $http.post(url, payload).then(function(response) {
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error)
            });
            return deferred.promise;
          }

          TenantModel.cardActionHandled = function(transaction) {
            var deferred = $q.defer();
            var url = transaction._links['px:cardActionHandled'].href;
            $http.get(url).then(function(response) {
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }

          TenantModel.cancelTransaction = function(transaction) {
            var deferred = $q.defer();
            var url = transaction._links.self.href;
            $http.delete(url).then(function(response) {
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }

          TenantModel.retryPayment = function(transaction) {
            var deferred = $q.defer();
            var url = transaction._links['px:retryChargingCard'].href;
            $http.get(url).then(function(response) {
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }

          TenantModel.confirmPayment = function(transaction) {
            var deferred = $q.defer();
            var url = transaction._links['px:confirmPayment'].href;
            $http.get(url).then(function(response) {
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }

          TenantModel.getTransactions = function (chargesUrl, transactionListPaging) {
            var deferred = $q.defer();
            var url = chargesUrl + transactionListPaging.getPagedUrlParameters() + '&omitHidden=true' + '&embed=ui';
            $http.get(url).then(function(response) {
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });

            return deferred.promise;
          }

          TenantModel.sendStripeToken = function(token, billingData) {
            if (token) {
              var dataToSend = {
                stripeToken: token
              };
              var deferred = $q.defer();
              $http.post(billingData._links["px:stripeToken"].href, dataToSend).then(function(response) {
                deferred.resolve(response)
              }).catch(function(error) {
                deferred.reject(error);
              });
              return deferred.promise;
            } else {
              throw "TenantModelPrivate.sendStripeToken: token is missing";
            }
          };

          TenantModel.getFeatureConfigInfo = function(urlKey) {
            if (urlKey && TenantModel.info._embedded.productsAndFeatures._links[urlKey] && TenantModel.info._embedded.productsAndFeatures._links[urlKey].href) {
              return $http.get(TenantModel.info._embedded.productsAndFeatures._links[urlKey].href);
            } else {
              throw "TenantModel.getFeatureConfigInfo: urlKey or TenantModel.info._links[urlKey].href are missing";
            }
          };

          TenantModel.changeFeatureConfigInfo = function(urlKey, originalFeatureConfigInfo, changedFeatureConfigInfo) {
            if (urlKey && originalFeatureConfigInfo && changedFeatureConfigInfo && TenantModel.info._embedded.productsAndFeatures._links[urlKey]) {
              var patchObjectArray = Utils.getObjectsDifferencesForPatching(originalFeatureConfigInfo, changedFeatureConfigInfo);
              if (patchObjectArray && patchObjectArray.length > 0) {
                return $http.patch(TenantModel.info._embedded.productsAndFeatures._links[urlKey].href, patchObjectArray);
              } else {
                return $q.resolve();
              }
            } else {
              throw "TenantModelPrivate.changeFeatureConfigInfo: url or originalFeatureConfigInfo or changedFeatureConfigInfo or TenantModel.info._embedded.productsAndFeatures._links[urlKey] are missing";
            }
          };

          TenantModel.changeFeaturesInfo = function(tenantChanged) {
            if (tenantChanged) {
              var patchObjectArray = Utils.getObjectsDifferencesForPatching(TenantModel.info._embedded.productsAndFeatures, tenantChanged.info._embedded.productsAndFeatures);
              angular.forEach(patchObjectArray, function(patchObject) {
                if (patchObject.path.indexOf("products") > -1) {
                  patchObjectArray.splice(patchObjectArray.indexOf(patchObject), 1);
                }
              });
              if (patchObjectArray && patchObjectArray.length > 0) {
                var deferred = $q.defer();
                $http.patch(TenantModel.info._embedded.productsAndFeatures._links.self.href, patchObjectArray).then(function(response) {
                  TenantModelPrivate.replaceInfo("productsAndFeatures", response.data);
                  deferred.resolve(response);
                }).catch(function(error) {
                  deferred.reject(error);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw "TenantModelPrivate.changeFeaturesInfo: tenantChanged is missing";
            }
          };

          TenantModel.updateDriverConfigName = function(driverConfigName, os, driverConfigId, printer, printQueue) {
            var objectToSend = {
              name: driverConfigName,
              sourceConfigurationId: driverConfigId,
              printerId: printer.info._links.self.href,
              operatingSystem: os.key,
              queueId: printQueue.info._links.self.href
            };
            return $http.post(TenantModel.info._links["px:driverConfigurations"].href, objectToSend);
          }

          TenantModel.manageDriverConfig = function(driverConfigName, os, workstation, printer, printQueue, sourceConfiguration, onlyUploadConfiguration) {
            if (driverConfigName && os && workstation && printer && printQueue) {
              var objectToSend = {
                name: driverConfigName,
                workstationId: workstation._links.self.href,
                printerId: printer.info._links.self.href,
                operatingSystem: os.key,
                queueId: printQueue.info._links.self.href,
                onlyUploadConfiguration: onlyUploadConfiguration
              };
              if (sourceConfiguration) {
                objectToSend.replaceSource = false;
                objectToSend.sourceConfigurationId = sourceConfiguration._links.self.href;
              }
              return $http.post(TenantModel.info._links["px:driverConfigurations"].href, objectToSend);
            } else {
              throw "TenantModel.createDriverConfig: driverProfileName or operatingSystem or workstation or printer are missing";
            }
          };

          TenantModel.updateGoPrintersSoftware = function (printers) {
            var deferred = $q.defer();
            var url = TenantModel.info._links['px:updateOndevice'].href
            var payload = {
              printers: []
            }
            if (printers) {
              angular.forEach(printers, (printer) => {
                payload.printers.push(printer.info._links.self.href)
              })
              $http.post(url, payload).then(function(response) {
                deferred.resolve(response);
              }).catch(function(error) {
                deferred.reject(error);
              });
            } else {
              deferred.reject('No printers selected ')
            }

            return deferred.promise;
          }

          TenantModel.getTermsOfService = function () {
            const deferred = $q.defer();
            const url = TenantModel.info._links['px:termsOfService'].href;
            $http.get(url)
              .then(function (response) {
                deferred.resolve(response.data);
              })
              .catch(function (response) {
                deferred.reject(response);
              });
            return deferred.promise;
          };

          TenantModel.getTermsOfServiceStatus = function () {
            const deferred = $q.defer();
            const url = TenantModel.info._links['px:termsOfServiceStatus'].href;
            $http.get(url)
              .then(function (response) {
                deferred.resolve(response.data);
              })
              .catch(function (response) {
                deferred.reject(response);
              });
            return deferred.promise;
          };

          TenantModel.acceptTermsOfService = function (version) {
            const deferred = $q.defer();
            const url = TenantModel.info._links['px:termsOfServiceAcknowledgement'].href;
            const data = { version };
            $http.post(url, data)
              .then(function (response) {
                deferred.resolve();
              })
              .catch(function (response) {
                deferred.reject(response);
              });
            return deferred.promise;
          };

          //END TenantModel**************************************************************************************/

          //START SaveChanges************************************************************************************/
          TenantModel.saveAuthConfigChanges = function(tenantAuthConfigChanged) {
            if (tenantAuthConfigChanged) {
              var patchObjectArray = Utils.getObjectsDifferencesForPatching(TenantModel.info._embedded.authenticationConfiguration, tenantAuthConfigChanged);
              if (patchObjectArray && patchObjectArray.length > 0) {
                var deferred = $q.defer();
                $http.patch(TenantModel.info._embedded.authenticationConfiguration._links.self.href, patchObjectArray).then(function(response) {
                  TenantModelPrivate.replaceInfo("authenticationConfiguration", response.data);
                  deferred.resolve(response);
                }).catch(function(error) {
                  deferred.reject(error);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw "TenantModel.saveAuthConfigChanges: tenantAuthConfigChanged is missing";
            }
          };

          TenantModel.toggleAD = function (adToggleValue) {
            var patch = [{
              op: 'replace',
              path: '/ad/enabled',
              value: adToggleValue
            }];

            var deferred = $q.defer();
            $http.patch(TenantModel.info._embedded.authenticationConfiguration._links.self.href, patch).then(function(response) {
              TenantModelPrivate.replaceInfo("authenticationConfiguration", response.data);
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;

          };

          TenantModel.saveADConfig = function (adConfig) {
            var deferred = $q.defer()
            var patchObjectArray = Utils.getObjectsDifferencesForPatching(TenantModel.info._embedded.authenticationConfiguration.ad, adConfig);
            var url = TenantModel.info._embedded.authenticationConfiguration._links.self.href;
            if (patchObjectArray.length > 0) {
              $http.patch(url, patchObjectArray).then(function(response) {
                TenantModelPrivate.replaceInfo("authenticationConfiguration", response.data);
                deferred.resolve(response);
              }).catch(function(error) {
                deferred.reject(error);
              });
              return deferred.promise;
            } else {
              deferred.reject();
              return deferred.promise;
            }
          }

          TenantModel.getTenantPrinterVendors = function() {
            var deferred = $q.defer()
            var url = TenantModel.info._links['px:tenantVendors'].href;
            $http.get(url).then(function(response) {
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }

          TenantModel.synchronizeGroupsForIdentityProvider = function(providerOriginal, provider) {
            if (provider) {
              var patchObjectArray = Utils.getObjectsDifferencesForPatching(providerOriginal, provider);
              var deferred = $q.defer();
              $http.patch(provider._links.self.href, patchObjectArray).then(function(response){
                deferred.resolve(response);
              }).catch(function(error) {
                deferred.reject(error);
              });
              return deferred.promise;
            } else {
              throw "TenantModel.synchronizeGroupsForIdentityProvider: identityProvider is missing";
            }
          }

          TenantModel.convertWorkstationsPrintQueues = function (workstations) {
            var url = TenantModel.info._links['px:commandConvertWsQueues'].href;
            var deferred = $q.defer();
            $http.post(url, workstations).then(function(response){
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }

          TenantModel.saveChanges = function(tenantChanged) {
            if (tenantChanged) {
              var patchObjectArray = Utils.getObjectsDifferencesForPatching(TenantModel.info, tenantChanged.info);
              if (patchObjectArray && patchObjectArray.length > 0) {
                var deferred = $q.defer();
                $http.patch(TenantModel.info._links.self.href + TenantEmbeddedProperties, patchObjectArray).then(function(response) {
                  TenantModelPrivate.replaceInfo(null, response.data);
                  deferred.resolve(response);
                }).catch(function(error) {
                  deferred.reject(error);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw "TenantModel.saveChanges: tenantChanged is missing";
            }
          };

          TenantModel.getSnmpConfigurations = function (url) {
            var deferred = $q.defer();
            $http.get(url).then(function(response) {
              deferred.resolve(response.data);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }

          TenantModel.saveChangesSecuritySettings = function(url, tenantChanged) {
            if (tenantChanged) {
              var patchObjectArray = Utils.getObjectsDifferencesForPatching(TenantModel.info._embedded.securePrintConfiguration, tenantChanged.info._embedded.securePrintConfiguration);
              if (patchObjectArray && patchObjectArray.length > 0) {
                var deferred = $q.defer();
                patchObjectArray = removeBlackListedPathsFromPatchObjectArray(patchObjectArray)

                $http.patch(url, patchObjectArray).then(function(response) {
                  deferred.resolve(response);
                }).catch(function(error) {
                  deferred.reject(error);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw "TenantModel.saveChanges: tenantChanged is missing";
            }
          };

          function removeBlackListedPathsFromPatchObjectArray(patchObjectArrayIN) {
            var blackListedPaths = ['/mustPrintSecurelyGroups', '/printLaterByDefaultGroups']
            var patchObjectArray = angular.copy(patchObjectArrayIN)
            for (var i = 0; i < patchObjectArray.length; i++) {
              for (var j = 0; j < blackListedPaths.length; j++) {
                if (patchObjectArray[i]) {
                  if (patchObjectArray[i].path === blackListedPaths[j]) {
                    patchObjectArray.splice(i, 1);
                    i--;
                  }
                }
              }
            }

            return patchObjectArray;
          }

          TenantModel.toggleSecurePrint = function(url, tenantChanged) {
            if (tenantChanged) {
              var patchObjectArray = Utils.getObjectsDifferencesForPatching(TenantModel.info._embedded.productsAndFeatures, tenantChanged.info._embedded.productsAndFeatures);
              if (patchObjectArray && patchObjectArray.length > 0) {
                var deferred = $q.defer();
                $http.patch(url, patchObjectArray).then(function(response) {
                  TenantModelPrivate.replaceInfo("productsAndFeatures", response.data);
                  deferred.resolve(response);
                }).catch(function(error) {
                  deferred.reject(error);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw "TenantModel.saveChanges: tenantChanged is missing";
            }
          };

          TenantModel.patchUserSecretAuthenticationConfig = function (path, value) {
            var deferred = $q.defer()
            var patch = [{
              op: 'replace',
              path: path,
              value: value,
            }];
            var url = TenantModel.info._embedded.authenticationConfiguration._links.self.href;
            $http.patch(url, patch).then(function(response) {
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }
          //END SaveChanges**************************************************************************************/


          //START CREATE*****************************************************************************************/
          TenantModel.init(tenantDataReceived);
          delete TenantModel.init;
          //END CREATE*******************************************************************************************/


          return TenantModel;
        };
      }
    ])

    .factory('TransactionsListPaging', ['TRANSACTIONS_ITEMS_PER_PAGE',
      function(TRANSACTIONS_ITEMS_PER_PAGE) {
        return function () {
          var TransactionListPaging = {};
          TransactionListPaging.pagingCriteria = {
            page: 0,
            pageSize: TRANSACTIONS_ITEMS_PER_PAGE,
            direction: 'ASC',
            match: null,
            sort: 'DATE'
          }

          TransactionListPaging.getPagedUrlParameters = function() {
            var urlParameters =
            '?page=' + TransactionListPaging.pagingCriteria.page +
            '&pageSize=' + TransactionListPaging.pagingCriteria.pageSize;

            return urlParameters;
          }
          return TransactionListPaging;
        }
    }])

    .service('TenantListService', function (
      $filter, $http, $injector, $location, $q, $rootScope, $ngBootbox,
      EnvironmentService, Utils, TenantModel, URLS, API_VALUES, TenantEmbeddedProperties, USER_RIGHTS) {

      let EventServiceEvents = null;
      try {
        EventServiceEvents = $injector.get('EventServiceEvents');
      } catch (e) {}

      const TenantsListModelPrivate = {};
      const tenantListServiceAsObject = this;

      TenantsListModelPrivate.currentTenantUrl = EnvironmentService.apiBaseUrl + '/v1/tenants/' + $location.host() + TenantEmbeddedProperties;

      this.tenantUrl = TenantsListModelPrivate.currentTenantUrl;
      this.currentTenant = null;
      this.list = [];

      this.resolveCurrentTenant = function () {
        if (!tenantListServiceAsObject.currentTenantPromise) {
          const deferred = $q.defer();
          $http.get(TenantsListModelPrivate.currentTenantUrl)
            .then(function (response) {
              tenantListServiceAsObject.currentTenant = new TenantModel(response.data);
              tenantListServiceAsObject.currentTenant.info.groupsEnabled = tenantListServiceAsObject.currentTenant.isGroupsEnabled(response.data);
              deferred.resolve(tenantListServiceAsObject.currentTenant);
            })
            .catch(function (error) {
              tenantListServiceAsObject.currentTenantPromise = undefined;
              deferred.reject(error);
            });
          tenantListServiceAsObject.currentTenantPromise = deferred.promise;
        }
        return tenantListServiceAsObject.currentTenantPromise;
      };

      TenantsListModelPrivate.getCurrentTenant = function () {
        return tenantListServiceAsObject.resolveCurrentTenant();
      };

      TenantsListModelPrivate.startListeningAdminChannels = function () {

        $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TODO_REMOVED, function (event, data) {
          $http.get(tenantListServiceAsObject.currentTenant.info._links['px:toDos'].href)
            .then(function (response) {
              tenantListServiceAsObject.currentTenant.info._embedded.toDos = response.data._embedded.toDos;
              tenantListServiceAsObject.currentTenant.info.todoMap = tenantListServiceAsObject.currentTenant.setTodoListMap();
              $rootScope.$broadcast('CHECK_TODO_LIST');
            })
            .catch(function () {
              $rootScope.$broadcast('CHECK_TODO_LIST');
            });
        });

        $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TASK_PROGRESS_ADMIN, function (event, data) {
          if (tenantListServiceAsObject.currentTenant) {
            tenantListServiceAsObject.currentTenant.manageProgressingTasks(data);
          }
        });

        $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.TENANT_UPDATED, function (event, data) {
          if (tenantListServiceAsObject.currentTenant) {
            tenantListServiceAsObject.currentTenant.refreshInfo();
          }
        });

        $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.BILLING_DATA_UPDATED, function (event, data) {
          if (tenantListServiceAsObject.currentTenant) {
            tenantListServiceAsObject.currentTenant.refreshInfo();
          }
        });

        $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.AUTH_CONFIG_UPDATED, function (event, data) {
          if (tenantListServiceAsObject.currentTenant) {
            tenantListServiceAsObject.currentTenant.refreshInfo();
          }
        });

        $rootScope.$on(EventServiceEvents.CHANNELS.SPECIFIC_USER.EVENTS.TASK_PROGRESS_USER, function (event, data) {
          if (tenantListServiceAsObject.currentTenant) {
            tenantListServiceAsObject.currentTenant.manageProgressingTasks(data);
          }
        });

        $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_STATS_UPDATED, function (event, data) {
          if (tenantListServiceAsObject.currentTenant) {
            tenantListServiceAsObject.currentTenant.refreshInfo();
          }
        });

      };

      if (EventServiceEvents) {
        const deregisterWatchCurrentUser = $rootScope.$watch(function () {
          return $rootScope.currentUser;
        }, function () {
          if ($rootScope.currentUser?.info &&
              $filter('contains')($rootScope.currentUser.info._embedded.permissions.permissions, USER_RIGHTS.ADMIN_LOGIN)) {
            TenantsListModelPrivate.startListeningAdminChannels();
            deregisterWatchCurrentUser();
          }
        });
      }

      TenantsListModelPrivate.getCurrentTenant();

      $rootScope.TenantListService = tenantListServiceAsObject;

      $rootScope.$watch(function () {
        return tenantListServiceAsObject.currentTenant?.info.todoMap?.SHOW_INTRODUCTION;
      }, function () {
        if (tenantListServiceAsObject.currentTenant?.info.todoMap?.SHOW_INTRODUCTION) {
          $location.path(URLS.SETUP);
        }
      });

    });

})();
